export default {
  entities: {
    clientCard: {
      cardExpiresSoonAlert: 'Истекает срок карты',
    },
  },
};
